/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsAnnouncementBar = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAnnouncementBar = $.extend(this, window.PXUTheme.getSectionData($section));

    let template = this.homepage_only ? '.index' : '';
    this.$el = $('#announcement-bar', template);
    let announcementCookie = Cookies.get('announcement-bar');
    $('.announcement-bar__shadow').height(this.$el.height());

    if (this.show_close_icon === false) {
      // Close icon is disabled, always show announcement
      Cookies.remove('announcement-bar');
      $('body').addClass('announcement-bar--visible');
    } else if (announcementCookie !== 'dismiss') {
      // Close icon has not been clicked
      $('body').addClass('announcement-bar--visible');
    } else {
      // Close icon has been clicked and announcement is hidden
      $('body').addClass('announcement-bar--hidden');
      this.disableSticky();
      return false;
    }

    // Sticky announcement bar
    if (this.enable_sticky === true) {
      this.enableSticky();
    } else {
      this.disableSticky();
    }

    // Hide announcement by default, but then hide or show based on close icon status
    if (this.show_close_icon === true) {
      $('body').addClass('has-announcement-bar-toggle');

      // Attach event to hide announcement if close icon is clicked
      this.$el.on('click', '.js-close-announcement', () => {
        this.hide();
      });
    }
  },
  enableSticky: function() {
    const stickyPin = window.PXUTheme.stickyPin;

    this._teardownSticky();

    if (!this.$el || !this.$el.length) return;

    const $stickyEl = this.$el.parent(); // .announcement-bar__container
    if (!$stickyEl.length) return;

    const $wrapper = stickyPin.wrap($stickyEl, 'announcement-sticky-wrapper');
    $wrapper.addClass('is-sticky');

    const pin = () => {
      const height = $stickyEl.outerHeight() || 0;

      stickyPin.lockSpacer($wrapper, height);
      stickyPin.applyFixed($stickyEl, 0, 90);
      $stickyEl.closest('.announcement-container').css({
        height: height,
        minHeight: height,
        overflow: 'visible'
      });
      stickyPin.syncSpacers();

      // Keep desktop/mobile header nested under the announcement after size changes
      this._syncHeaderOffset(height);
    };

    pin();
    $(window).on('resize.announcementPinSticky', pin);
  },
  _syncHeaderOffset: function(offset) {
    if (!window.PXUTheme.jsHeader || window.PXUTheme.jsHeader.enable_sticky !== true) return;
    if (window.PXUTheme.theme_settings.header_layout === 'vertical') return;

    const top = typeof offset === 'number' ? offset : window.PXUTheme.stickyPin.getAnnouncementOffset();

    if (isScreenSizeLarge()) {
      const $header = $('#header.sticky--enabled');
      if ($header.length && $header.parent().attr('data-pin-sticky') === 'true') {
        $header.css('top', top);
        if (typeof window.PXUTheme.jsHeader._updateSearchOverlayOffset === 'function') {
          window.PXUTheme.jsHeader._updateSearchOverlayOffset($header);
        }
        window.PXUTheme.stickyPin.syncSpacers();
        return;
      }

      window.PXUTheme.jsHeader.enableSticky(top);
      return;
    }

    const $mobileHeader = $('#mobile-header.sticky--enabled');
    if ($mobileHeader.length && $mobileHeader.parent().attr('data-pin-sticky') === 'true') {
      $mobileHeader.css('top', top);
      window.PXUTheme.stickyPin.syncSpacers();
      return;
    }

    window.PXUTheme.mobileMenu.enableSticky();
  },
  _teardownSticky: function() {
    const stickyPin = window.PXUTheme.stickyPin;

    $(window).off('.announcementPinSticky');

    if (!this.$el || !this.$el.length) return;

    const $stickyEl = this.$el.parent();
    if (!$stickyEl.length) return;

    $stickyEl.closest('.announcement-container').css({
      height: '',
      minHeight: '',
      overflow: ''
    });
    stickyPin.unwrap($stickyEl, 'announcement-sticky-wrapper');
    stickyPin.syncSpacers();
  },
  disableSticky: function() {
    this._teardownSticky();
    this.resetHeader(0);
  },
  hide: function() {
    // Remove announcement bar and set cookie to hide it for 30 days
    $('body').removeClass('announcement-bar--visible');
    this.disableSticky();
    Cookies.set('announcement-bar', 'dismiss', { expires: 30 });
  },
  resetHeader: function(offset) {
    this._syncHeaderOffset(typeof offset === 'number' ? offset : 0);
  },
  getAnnouncementHeight() {
    return $('.announcement-container').outerHeight() || 0;
  },
  unload: function($section) {
    // Clear event listeners in theme editor
    $('#announcement-bar').off();
    this._teardownSticky();
  }
}

/******/ })()
;
